import Wrapper from '@app/Wrapper.js'

Munio.ShopSuppliers = class extends Wrapper {
  constructor(selector) {
    super(selector)
  }

  component() {
    return import('./Creator.vue')
  }
}
